/**
 * APIのベースURL
 * @type {string}
 */
const API_BASE_DOCTOR = '/doctor/api'
const API_BASE_ADMIN = '/admin'
const API_BASE_EX = '/ex'

/**
 * 問診タイプ
 * @type {number}
 */
const INTERVIEW_QUESTION_INPUT = 1
const INTERVIEW_QUESTION_MULTI_INPUT = 2
const INTERVIEW_QUESTION_CHECK = 11
const INTERVIEW_QUESTION_RADIO = 21

/**
 * 相談ステータス
 * @type {number}
 */
const STATUS_CONSULTATION_RESERVED = 1                   // 予約
const STATUS_CONSULTATION_HOLD = 2                       // 相談中
const STATUS_CONSULTATION_CONFIRMED = 3                  // 予約確定
const STATUS_CONSULTATION_CANCELED_USER = 4              // キャンセル（会員）
const STATUS_CONSULTATION_CANCELED_DOCTOR = 5            // キャンセル（医師）
const STATUS_CONSULTATION_CANCELED_CONFIRMED_USER = 6    // 確定後キャンセル（会員）
const STATUS_CONSULTATION_CANCELED_CONFIRMED_DOCTOR = 7  // 確定後キャンセル（医師）
const STATUS_CONSULTATION_FINISHED_ABSENCE_USER = 8      // 未入室終了（ユーザ）
const STATUS_CONSULTATION_FINISHED_ABSENCE_DOCTOR = 9    // 未入室終了（医師）
const STATUS_CONSULTATION_FINISHED = 11                  // 相談終了

/**
 * 相談キャンセル分類
 * @type {string }
 */
const CANCEL_CATEGORY_DOCTOR_LOGIN = 'DOCTOR_LOGIN'
const CANCEL_CATEGORY_CONSULTATION_CHANGED = 'CONSULTATION_CHANGED'

/**
 * 法人フィードバックステータス
 * @type {number}
 */
const STATUS_FEEDBACK_FINE = 1    // 問題なし
const STATUS_FEEDBACK_CAREFUL = 2 // 要観察
const STATUS_FEEDBACK_WARNING = 3 // 要対応

/**
 * 決済方法
 * @type {number}
 */
const METHOD_CREDIT = 1  // クレジットカード
const METHOD_CASH = 2    // 現金
const METHOD_BANK = 3    // 銀行振込
const METHOD_INVOICE_LATER = 4 // 請求書後払い（月末に一括で手動オペレーションによる請求書払い。自動請求周りの挙動は銀行振込と同じだが、請求書送付や決済完了のメールは飛ばさない）

/**
 * 決済ステータス
 * @type {number}
 */
const STATUS_INVOICE_DRAFT = 1          // Stripe: 下書き
const STATUS_INVOICE_OPEN = 2           // Stripe: オープン
const STATUS_INVOICE_FAILED = 3
const STATUS_INVOICE_PAID = 4           // Stripe: 支払い済み
const STATUS_INVOICE_UNCOLLECTIBLE = 5  // Stripe: 回収不能
const STATUS_INVOICE_VOID = 6           // Stripe: 無効
const STATUS_INVOICE_REFUNDED = 7
const STATUS_INVOICE_AUTHORIZED = 11
const STATUS_INVOICE_AUTHORIZE_FAILED = 12
const STATUS_INVOICE_CANCELED = 13
const STATUS_INVOICE_CONFIRMED = 14     // 請求確定済（法人会員向け）

/**
 * プラン
 */
const PLAN_PAY_PER = 'PAY_PER'
const PLAN_TRAVEL = 'TRAVEL'
const PLAN_STUDY_ABROAD = 'STUDY_ABROAD'
const PLAN_TRAVEL_FREE = 'TRAVEL_FREE'
const PLAN_STUDY_ABROAD_FREE = 'STUDY_ABROAD_FREE'
const PLAN_FLAT_RATE = 'FLAT_RATE'

/**
 * プランタイプ
 */
const PLAN_TYPE_FREE = 'FREE'
const PLAN_TYPE_PURCHASE = 'PURCHASE'
const PLAN_TYPE_CYCLE = 'CYCLE'

/**
 * サイクル単位
 */
const CYCLE_UNIT_NONE = 'NONE'
const CYCLE_UNIT_DAILY = 'DAILY'
const CYCLE_UNIT_MONTHLY = 'MONTHLY'

/**
 * 課金対象
 */
const BILLING_TARGET_ORGANIZATION = 'ORGANIZATION'
const BILLING_TARGET_COMPANY = 'COMPANY'
const BILLING_TARGET_PERSONAL = 'PERSONAL'

/**
 * クーポンカテゴリ
 * @type {number}
 */
const COUPON_CATEGORY_CONSULTATION = 1
const COUPON_CATEGORY_PLAN = 2

/**
 * 発行クーポンステータス
 * @type {number}
 */
const STATUS_USER_COUPON_PUBLISHED = 1
const STATUS_USER_COUPON_USED = 2

/**
 * 設定カテゴリ
 *
 * @see ConfigurationCategory.php
 */
const CONF_CONSULTATION = 1
const CONF_MAIL = 2
const CONF_BASIC = 3
const CONF_MEDICALRECORD = 4
const CONF_PAYMENT = 5
const CONF_TIMEZONE = 6
const CONF_USER = 7
const CONF_LAW = 8
const CONF_INVOICE = 9
const CONF_SUBSCRIPTION = 10
const CONF_ADMIN = 11
const CONF_CAMPAIGN = 12
const CONF_MAINTENANCE = 13

/**
 * 設定値タイプ
 *
 * @see ConfigurationValue.php
 */
const CONF_VALUE_INT = 1
const CONF_VALUE_STR = 2
const CONF_VALUE_TEXT = 3
const CONF_VALUE_IMAGE = 4
const CONF_VALUE_BOOL = 5
const CONF_VALUE_DATETIME = 6

/**
 * グループタイプ
 */
const GROUP_TYPE_COMPANY = 1
const GROUP_TYPE_ORGANIZATION = 2

const STATUS_DOCTOR_MENU_PUBLISHED = 1
const STATUS_DOCTOR_MENU_UNPUBLISHED = 2

const STATUS_SUBSCRIPTION_NOT_STARTED = 'NOT_STARTED'
const STATUS_SUBSCRIPTION_ACTIVE = 'ACTIVE'
const STATUS_SUBSCRIPTION_PAUSED = 'PAUSED'
const STATUS_SUBSCRIPTION_CANCELED = 'CANCELED'
const STATUS_SUBSCRIPTION_REVOKED = 'REVOKED'
const STATUS_SUBSCRIPTION_DELETED = 'DELETED'

/**
 * グループ招待
 */
const STATUS_GROUP_INVITATION_INVITING = 'INVITING'
const STATUS_GROUP_INVITATION_DONE = 'DONE'
const STATUS_GROUP_INVITATION_REVOKED = 'REVOKED'

/**
 * ソーシャルログインプロバイダ
 * @type {number}
 */
const SOCIAL_OAUTH_PROVIDER_LINE = 1
const SOCIAL_OAUTH_PROVIDER_APPLE = 2

/**
 * ヘルスアンサー
 */
const STATUS_HEALTH_SURVEY_ACTIVE = 'ACTIVE'
const STATUS_HEALTH_SURVEY_PAUSED = 'PAUSED'
const STATUS_HEALTH_SURVEY_FINISHED = 'FINISHED'

export default {
    /**
     * 昇順降順
     */
    orders: [
        { value: 0, text: '昇順' },
        { value: 1, text: '降順' },
    ],

    /**
     * 曜日リスト
     */
    days: [
        '日', '月', '火', '水', '木', '金', '土'
    ],

    /**
     * 診察スケジュール
     * 診察間隔
     */
    minutes_intervals: [
        15, 30, 60
    ],

    /**
     * 診察スケジュール
     * 列時間間隔
     */
    column_hours: [
        0, 4, 8, 12, 16, 20
    ],

    /**
     * 問診タイプ
     */
    interview_question_types: {
        all: [
            { value: INTERVIEW_QUESTION_INPUT, text: '記述' },
            { value: INTERVIEW_QUESTION_MULTI_INPUT, text: '記述（複数行）' },
            { value: INTERVIEW_QUESTION_CHECK, text: 'チェックボックス' },
            { value: INTERVIEW_QUESTION_RADIO, text: 'ラジオボタン' },
        ],
        input: INTERVIEW_QUESTION_INPUT,
        multiInput: INTERVIEW_QUESTION_MULTI_INPUT,
        check: INTERVIEW_QUESTION_CHECK,
        radio: INTERVIEW_QUESTION_RADIO,
    },

    /**
     * 相談
     */
    consultations: {
        all: [
            { value: STATUS_CONSULTATION_RESERVED, css: 'c-indicator--blue', text: '予約' },
            { value: STATUS_CONSULTATION_HOLD, css: 'c-indicator--green', text: '診療中' },
            { value: STATUS_CONSULTATION_CONFIRMED, css: 'c-indicator--dark-blue', text: '予約確定' },
            { value: STATUS_CONSULTATION_CANCELED_USER, css: 'c-indicator--orange', text: 'キャンセル（患者）' },
            { value: STATUS_CONSULTATION_CANCELED_DOCTOR, css: 'c-indicator--orange', text: 'キャンセル（医師）' },
            { value: STATUS_CONSULTATION_CANCELED_CONFIRMED_USER, css: 'c-indicator--orange', text: '確定後キャンセル（患者）' },
            { value: STATUS_CONSULTATION_CANCELED_CONFIRMED_DOCTOR, css: 'c-indicator--orange', text: '確定後キャンセル（医師）' },
            { value: STATUS_CONSULTATION_FINISHED_ABSENCE_USER, css: 'c-indicator--violet', text: '未入室終了（患者）' },
            { value: STATUS_CONSULTATION_FINISHED_ABSENCE_DOCTOR, css: 'c-indicator--violet', text: '未入室終了（医師）' },
            { value: STATUS_CONSULTATION_FINISHED, css: 'c-indicator--gray', text: '診療終了' },
        ],
        cancelAll: [
            STATUS_CONSULTATION_CANCELED_USER,
            STATUS_CONSULTATION_CANCELED_DOCTOR,
            STATUS_CONSULTATION_CANCELED_CONFIRMED_USER,
            STATUS_CONSULTATION_CANCELED_CONFIRMED_DOCTOR,
        ],
        absenceAll: [
            STATUS_CONSULTATION_FINISHED_ABSENCE_USER,
            STATUS_CONSULTATION_FINISHED_ABSENCE_DOCTOR,
        ],
        closedAll: [
            STATUS_CONSULTATION_CANCELED_USER,
            STATUS_CONSULTATION_CANCELED_DOCTOR,
            STATUS_CONSULTATION_CANCELED_CONFIRMED_USER,
            STATUS_CONSULTATION_CANCELED_CONFIRMED_DOCTOR,
            STATUS_CONSULTATION_FINISHED_ABSENCE_USER,
            STATUS_CONSULTATION_FINISHED_ABSENCE_DOCTOR,
            STATUS_CONSULTATION_FINISHED,
        ],
        canEnterAll: [
            STATUS_CONSULTATION_RESERVED,
            STATUS_CONSULTATION_CONFIRMED,
            STATUS_CONSULTATION_HOLD,
            STATUS_CONSULTATION_FINISHED,
            STATUS_CONSULTATION_CANCELED_CONFIRMED_USER,
            STATUS_CONSULTATION_FINISHED_ABSENCE_USER,
        ],
        canStartUserAll: [
            STATUS_CONSULTATION_CONFIRMED,
            STATUS_CONSULTATION_HOLD,
        ],
        canStartDoctorAll: [
            STATUS_CONSULTATION_CONFIRMED,
        ],
        canCancelAll: [
            STATUS_CONSULTATION_RESERVED,
            STATUS_CONSULTATION_CONFIRMED,
        ],
        canFinishAll: [
            STATUS_CONSULTATION_HOLD,
        ],
        canRestartAll: [
            STATUS_CONSULTATION_FINISHED,
        ],
        canPublishAll: [
            STATUS_CONSULTATION_CANCELED_CONFIRMED_USER,
            STATUS_CONSULTATION_FINISHED,
            STATUS_CONSULTATION_FINISHED_ABSENCE_USER,
        ],
        asSkipAuthorization: {
            canStartUserAll: [
                STATUS_CONSULTATION_RESERVED,
                STATUS_CONSULTATION_CONFIRMED,
                STATUS_CONSULTATION_HOLD,
            ],
            canStartDoctorAll: [
                STATUS_CONSULTATION_RESERVED,
                STATUS_CONSULTATION_CONFIRMED,
            ],
        },
        reserved: STATUS_CONSULTATION_RESERVED,
        hold: STATUS_CONSULTATION_HOLD,
        finished: STATUS_CONSULTATION_FINISHED,
        confirmed: STATUS_CONSULTATION_CONFIRMED,
        canceledUser: STATUS_CONSULTATION_CANCELED_USER,
        canceledDoctor: STATUS_CONSULTATION_CANCELED_DOCTOR,
        canceledAuthUser: STATUS_CONSULTATION_CANCELED_CONFIRMED_USER,
        canceledAuthDoctor: STATUS_CONSULTATION_CANCELED_CONFIRMED_DOCTOR,
        absenceUser: STATUS_CONSULTATION_FINISHED_ABSENCE_USER,
        absenceDoctor: STATUS_CONSULTATION_FINISHED_ABSENCE_DOCTOR,
    },

    /**
     * 相談キャンセル分類
     */
    cancelCategory: {
        doctorLogin: CANCEL_CATEGORY_DOCTOR_LOGIN,
        consultationChanged: CANCEL_CATEGORY_CONSULTATION_CHANGED,
    },

    consultation_feedback: {
        all: [
            { value: STATUS_FEEDBACK_FINE, text: '問題なし', css: 'background: #9ECCF5;' },
            { value: STATUS_FEEDBACK_CAREFUL, text: '要観察', css: 'background: #F9CC6E;' },
            { value: STATUS_FEEDBACK_WARNING, text: '要対応', css: 'background: #F57886;' },
        ],
        fine: STATUS_FEEDBACK_FINE,
        careful: STATUS_FEEDBACK_CAREFUL,
        warning: STATUS_FEEDBACK_WARNING,
    },

    /**
     * 決済方法
     */
    payment_methods: {
        all: [
            { value: METHOD_CREDIT, text: 'クレジットカード' },
            { value: METHOD_CASH, text: '現金' },
            { value: METHOD_BANK, text: '銀行振込' },
            { value: METHOD_INVOICE_LATER, text: '請求書後払い' },
        ],
        credit: METHOD_CREDIT,
        cash: METHOD_CASH,
        bank: METHOD_BANK,
        invoiceLater: METHOD_INVOICE_LATER,
        creditText: 'クレジットカード',
        cashText: '現金',
        bankText: '銀行振込',
        invoiceLaterText: '請求書後払い',
    },

    /**
     * 請求書
     */
    invoices: {
        all: [
            { value: STATUS_INVOICE_DRAFT, text: '未請求' },
            { value: STATUS_INVOICE_OPEN, text: '請求済' },
            { value: STATUS_INVOICE_FAILED, text: '支払失敗' },
            { value: STATUS_INVOICE_PAID, text: '支払済' },
            { value: STATUS_INVOICE_UNCOLLECTIBLE, text: '回収不能' },
            { value: STATUS_INVOICE_VOID, text: '無効' },
            { value: STATUS_INVOICE_REFUNDED, text: '返金' },
            { value: STATUS_INVOICE_AUTHORIZED, text: '確定済' },
            { value: STATUS_INVOICE_AUTHORIZE_FAILED, text: '確定失敗' },
            { value: STATUS_INVOICE_CANCELED, text: 'キャンセル' },
            { value: STATUS_INVOICE_CONFIRMED, text: '請求確定済' },
        ],
        common: [
            { value: STATUS_INVOICE_DRAFT, text: '未請求' },
            { value: STATUS_INVOICE_OPEN, text: '請求済' },
            { value: STATUS_INVOICE_FAILED, text: '支払失敗' },
            { value: STATUS_INVOICE_PAID, text: '支払済' },
            { value: STATUS_INVOICE_REFUNDED, text: '返金' },
            { value: STATUS_INVOICE_AUTHORIZED, text: '確定済' },
            { value: STATUS_INVOICE_AUTHORIZE_FAILED, text: '確定失敗' },
            { value: STATUS_INVOICE_CANCELED, text: 'キャンセル' },
            { value: STATUS_INVOICE_CONFIRMED, text: '請求確定済' },
        ],
        errors: [
            STATUS_INVOICE_FAILED,
            STATUS_INVOICE_AUTHORIZE_FAILED,
        ],
        draft: STATUS_INVOICE_DRAFT,
        open: STATUS_INVOICE_OPEN,
        paid: STATUS_INVOICE_PAID,
        failed: STATUS_INVOICE_FAILED,
        uncollectible: STATUS_INVOICE_UNCOLLECTIBLE,
        void: STATUS_INVOICE_VOID,
        refunded: STATUS_INVOICE_REFUNDED,
        authorized: STATUS_INVOICE_AUTHORIZED,
        authorizeFailed: STATUS_INVOICE_AUTHORIZE_FAILED,
        canceled: STATUS_INVOICE_CANCELED,
        confirmed: STATUS_INVOICE_CONFIRMED,
    },

    /**
     * プラン
     */
    plans: {
        payPer: PLAN_PAY_PER,
        travel: PLAN_TRAVEL,
        studyAbroad: PLAN_STUDY_ABROAD,
        travelFree: PLAN_TRAVEL_FREE,
        studyAbroadFree: PLAN_STUDY_ABROAD_FREE,
        flatRate: PLAN_FLAT_RATE,
        common: [
            PLAN_PAY_PER,
            PLAN_TRAVEL,
            PLAN_STUDY_ABROAD,
            PLAN_FLAT_RATE,
        ],
    },

    /**
     * プランタイプ
     */
    planTypes: {
        selectable: [
            { value: PLAN_TYPE_PURCHASE, text: '買い切り' },
        ],
        free: PLAN_TYPE_FREE,
        purchase: PLAN_TYPE_PURCHASE,
        cycle: PLAN_TYPE_CYCLE,
    },

    /**
     * サイクル単位
     */
    cycleUnits: {
        selectable: [
            { value: CYCLE_UNIT_DAILY, text: '日次' },
        ],
        none: CYCLE_UNIT_NONE,
        daily: CYCLE_UNIT_DAILY,
        monthly: CYCLE_UNIT_MONTHLY,
    },

    /**
     * プランタイプ
     */
    billingTarget: {
        personal: BILLING_TARGET_PERSONAL,
        company: BILLING_TARGET_COMPANY,
        organization: BILLING_TARGET_ORGANIZATION,
    },

    /**
     * 医師メニュー
     */
    doctor_menus: {
        all: [
            { value: STATUS_DOCTOR_MENU_PUBLISHED, text: '公開中' },
            { value: STATUS_DOCTOR_MENU_UNPUBLISHED, text: '公開停止中' },
        ],
        published: STATUS_DOCTOR_MENU_PUBLISHED,
        unpublished: STATUS_DOCTOR_MENU_UNPUBLISHED,
    },

    /**
     * 発行クーポン
     */
    user_coupons: {
        all: [
            { value: STATUS_USER_COUPON_PUBLISHED, text: '未使用' },
            { value: STATUS_USER_COUPON_USED, text: '使用済' },
        ],
        published: STATUS_USER_COUPON_PUBLISHED,
        used: STATUS_USER_COUPON_USED,
    },

    /**
     * クーポンカテゴリ
     */
    couponCategory: {
        consultation: COUPON_CATEGORY_CONSULTATION,
        plan: COUPON_CATEGORY_PLAN,
    },

    /**
     * 設定カテゴリ
     */
    confCategory: {
        all: [
            { value: CONF_CONSULTATION },
            { value: CONF_MAIL },
            { value: CONF_BASIC },
            { value: CONF_MEDICALRECORD },
            { value: CONF_PAYMENT },
            { value: CONF_TIMEZONE },
            { value: CONF_USER },
            { value: CONF_LAW },
            { value: CONF_INVOICE },
            { value: CONF_SUBSCRIPTION },
            { value: CONF_ADMIN },
            { value: CONF_CAMPAIGN },
            { value: CONF_MAINTENANCE },
        ],
        consultation: CONF_CONSULTATION,
        mail: CONF_MAIL,
        basic: CONF_BASIC,
        medical_record: CONF_MEDICALRECORD,
        payment: CONF_PAYMENT,
        timezone: CONF_TIMEZONE,
        user: CONF_USER,
        law: CONF_LAW,
        invoice: CONF_INVOICE,
        subscription: CONF_SUBSCRIPTION,
        admin: CONF_ADMIN,
        campaign: CONF_CAMPAIGN,
        maintenance: CONF_MAINTENANCE,
    },

    /**
     * 設定タイプ
     */
    confValue: {
        all: [
            { value: CONF_VALUE_INT },
            { value: CONF_VALUE_STR },
            { value: CONF_VALUE_TEXT },
            { value: CONF_VALUE_IMAGE },
            { value: CONF_VALUE_BOOL },
            { value: CONF_VALUE_DATETIME },
        ],
        int: CONF_VALUE_INT,
        str: CONF_VALUE_STR,
        text: CONF_VALUE_TEXT,
        image: CONF_VALUE_IMAGE,
        bool: CONF_VALUE_BOOL,
        datetime: CONF_VALUE_DATETIME,
    },

    /**
     * グループタイプ
     */
    groupType: {
        all: [
            { value: GROUP_TYPE_COMPANY, text: '法人' },
            { value: GROUP_TYPE_ORGANIZATION, text: '団体' },
        ],
        company: GROUP_TYPE_COMPANY,
        organization: GROUP_TYPE_ORGANIZATION,
    },

    /**
     * グループ招待
     */
    groupInvitations: {
        all: [
            { value: STATUS_GROUP_INVITATION_INVITING, text: '発行済み' },
            { value: STATUS_GROUP_INVITATION_DONE, text: 'ログイン済み' },
            { value: STATUS_GROUP_INVITATION_REVOKED, text: '無効' },
        ],
        inviting: STATUS_GROUP_INVITATION_INVITING,
        done: STATUS_GROUP_INVITATION_DONE,
        revoked: STATUS_GROUP_INVITATION_REVOKED,
    },

    healthSurveys: {
        all: [
            { value: STATUS_HEALTH_SURVEY_ACTIVE, text: '受付中' },
            { value: STATUS_HEALTH_SURVEY_PAUSED, text: '一時停止' },
            { value: STATUS_HEALTH_SURVEY_FINISHED, text: '終了済' },
        ],
        active: STATUS_HEALTH_SURVEY_ACTIVE,
        paused: STATUS_HEALTH_SURVEY_PAUSED,
        finished: STATUS_HEALTH_SURVEY_FINISHED,
    },

    /**
     * サブスクリプション
     */
    subscriptions: {
        all: [
            { value: STATUS_SUBSCRIPTION_ACTIVE, text: '利用中' },
            { value: STATUS_SUBSCRIPTION_NOT_STARTED, text: '利用開始前' },
            { value: STATUS_SUBSCRIPTION_PAUSED, text: '利用停止中' },
            { value: STATUS_SUBSCRIPTION_CANCELED, text: 'キャンセル済み' },
            { value: STATUS_SUBSCRIPTION_REVOKED, text: '利用終了' },
            { value: STATUS_SUBSCRIPTION_DELETED, text: '利用終了' },
        ],
        common: [
            { value: STATUS_SUBSCRIPTION_ACTIVE, text: '利用中' },
            { value: STATUS_SUBSCRIPTION_NOT_STARTED, text: '利用開始前' },
            { value: STATUS_SUBSCRIPTION_PAUSED, text: '利用停止中' },
            { value: STATUS_SUBSCRIPTION_CANCELED, text: 'キャンセル済み' },
            { value: STATUS_SUBSCRIPTION_REVOKED, text: '利用終了' },
        ],
        enableAll: [
            STATUS_SUBSCRIPTION_ACTIVE,
            STATUS_SUBSCRIPTION_NOT_STARTED,
        ],
        active: STATUS_SUBSCRIPTION_ACTIVE,
        notStarted: STATUS_SUBSCRIPTION_NOT_STARTED,
        paused: STATUS_SUBSCRIPTION_PAUSED,
        canceled: STATUS_SUBSCRIPTION_CANCELED,
        revoked: STATUS_SUBSCRIPTION_REVOKED,
        deleted: STATUS_SUBSCRIPTION_DELETED,
    },

    /**
     * ソーシャルログインプロバイダ
     */
    socialOauthProvider: {
        all: [
            { value: SOCIAL_OAUTH_PROVIDER_LINE },
            { value: SOCIAL_OAUTH_PROVIDER_APPLE },
        ],
        line: SOCIAL_OAUTH_PROVIDER_LINE,
        apple: SOCIAL_OAUTH_PROVIDER_APPLE,
    },

    /**
     * 会員向け設定
     */
    user: {
        login: {
            endpoint: {
                base: '/login',
            },
        },
        register_provisional: {
            endpoint: {
                base: '/api/register/provisional',
            },
        },
        register: {
            endpoint: {
                base: '/api/register',
            },
        },
        leave: {
            endpoint: {
                base: '/api/leave',
            },
        },
        me: {
            endpoint: {
                base: '/api/me',
                new_user_coupons: '/api/me/user_coupons/new',
            },
        },
        medical_courses: {
            endpoint: {
                base: '/api/medical_courses',
            },
        },
        consultations: {
            endpoint: {
                base: '/api/consultations',
                next: '/api/consultations/next',
                nextTime: '/api/consultations/next_time',
                cancel: '/api/consultations/cancel',
                get_elapsed_time: '/api/consultation/get_elapsed_time',
            },
        },
        medical_records: {
            endpoint: {
                base: '/api/medical_records',
            },
        },
        consultation_message_images: {
            endpoint: {
                base: '/api/consultation_message_images',
            },
        },
        consultation_feedback: {
            endpoint: {
                base: '/api/consultation_feedback',
            },
        },
        doctors: {
            endpoint: {
                base: '/api/doctors',
            },
        },
        doctor_menus: {
            endpoint: {
                base: '/api/doctor_menus',
            },
        },
        schedules: {
            endpoint: {
                base: '/api/schedules',
            },
        },
        interview_trans_questions: {
            endpoint: {
                base: '/api/interview_trans_questions',
            },
        },
        interview_trans_answers: {
            endpoint: {
                base: '/api/interview_trans_answers',
            },
        },
        interview_trans_profiles: {
            endpoint: {
                base: '/api/interview_trans_profiles',
            },
        },
        interview_matching_questions: {
            endpoint: {
                base: '/api/interview_matching_questions',
            },
        },
        interview_common_questions: {
            endpoint: {
                base: '/api/interview_common_questions',
            },
        },
        interview_questions: {
            endpoint: {
                base: '/api/interview_questions',
            },
        },
        profile: {
            endpoint: {
                base: '/api/profile',
                timezone: '/api/timezone',
            },
        },
        email: {
            endpoint: {
                base: '/api/email',
            },
        },
        password: {
            endpoint: {
                base: '/api/password',
            },
        },
        configurations: {
            endpoint: {
                base: '/api/configurations',
            }
        },
        zip:{
            endpoint: {
                base: '/api/zip',
            }
        },
        credit_cards: {
            endpoint: {
                base: '/api/card',
                setup_intent: '/api/setup_intent',
            },
        },
        invoices: {
            endpoint: {
                base: '/api/invoices',
            }
        },
        subscriptions: {
            endpoint: {
                base: '/api/subscriptions',
            }
        },
        user_coupons: {
            endpoint: {
                base: '/api/user_coupons',
            }
        },
        social: {
            endpoint: {
                base: '/api/social',
            },
        },
        terms: {
            endpoint: {
                base: '/api/terms',
            },
        },
        groups: {
            endpoint: {
                base: '/api/groups',
            }
        },
        health_surveys: {
            endpoint: {
                base: '/api/health_surveys',
            }
        },
        health_survey_group_details: {
            endpoint: {
                base: '/api/health_survey_group_details',
            }
        },
        health_survey_logs: {
            endpoint: {
                base: '/api/health_survey_logs',
            }
        },
    },

    /**
     * 医師向け設定
     */
    doctor: {
        me: {
            endpoint: {
                base: `${API_BASE_DOCTOR}/me`,
            },
        },
        doctor_memo: {
            endpoint: {
                base: `${API_BASE_DOCTOR}/doctor_memo`,
            },
        },
        medical_courses: {
            endpoint: {
                base: `${API_BASE_DOCTOR}/medical_courses`,
            },
        },
        doctor_menus: {
            endpoint: {
                base: `${API_BASE_DOCTOR}/doctor_menus`,
            },
        },
        users: {
            endpoint: {
                base: `${API_BASE_DOCTOR}/users`,
                memo: `${API_BASE_DOCTOR}/users/memo`,
                timezone: `${API_BASE_DOCTOR}/timezone`,
                user_categories: `${API_BASE_DOCTOR}/user_categories`,
            }
        },
        doctors: {
            endpoint: {
                base: `${API_BASE_DOCTOR}/doctors`,
            },
        },
        consultations: {
            endpoint: {
                base: `${API_BASE_DOCTOR}/consultations`,
                nextTime: `${API_BASE_DOCTOR}/consultations/next_time`,
                today: `${API_BASE_DOCTOR}/consultations/today`,
                oneday: `${API_BASE_DOCTOR}/consultations/oneday`,
                doctorUsageRestriction: `${API_BASE_DOCTOR}/consultations/doctor_usage_restriction`,
                userLatest: `${API_BASE_DOCTOR}/consultations/user_latest`,
                images: `${API_BASE_DOCTOR}/consultation/images`,
                attachedImages: `${API_BASE_DOCTOR}/consultation/attached_images`,
                cancel: `${API_BASE_DOCTOR}/consultations/cancel`,
                update_elapsed_time:`${API_BASE_DOCTOR}/consultation/update_elapsed_time`,
            },
        },
        consultation_message_images: {
            endpoint: {
                base: `${API_BASE_DOCTOR}/consultation_message_images`,
            },
        },
        consultation_feedback: {
            endpoint: {
                base: `${API_BASE_DOCTOR}/consultation_feedback`,
            },
        },
        medical_records: {
            endpoint: {
                base: `${API_BASE_DOCTOR}/medical_records`,
            },
        },
        medical_record_templates: {
            endpoint: {
                base: `${API_BASE_DOCTOR}/medical_record_templates`,
            },
        },
        interview_common_questions: {
            endpoint: {
                base: `${API_BASE_DOCTOR}/interview_common_questions`,
            },
        },
        interview_questions: {
            endpoint: {
                base: `${API_BASE_DOCTOR}/interview_questions`,
            },
        },
        schedules: {
            endpoint: {
                base: `${API_BASE_DOCTOR}/schedules`,
                delete: `${API_BASE_DOCTOR}/schedules/delete`,
                deleteAll: `${API_BASE_DOCTOR}/schedules/delete/all`,
            },
        },
        exception_schedules: {
            endpoint: {
                base: `${API_BASE_DOCTOR}/exception_schedules`,
                date: `${API_BASE_DOCTOR}/exception_schedules/date`,
                storeClose: `${API_BASE_DOCTOR}/exception_schedules/close`,
                delete: `${API_BASE_DOCTOR}/exception_schedules/delete`,
            },
        },
        google_calendars: {
            endpoint: {
                base: `${API_BASE_DOCTOR}/google_calendars`,
            }
        },
        profile: {
            endpoint: {
                base: `${API_BASE_DOCTOR}/profile`,
                timezone: `${API_BASE_DOCTOR}/timezone`,
            },
        },
        password: {
            endpoint: {
                base: `${API_BASE_DOCTOR}/password`,
            },
        },
        email: {
            endpoint: {
                base: `${API_BASE_DOCTOR}/email`,
            },
        },
        configurations: {
            endpoint: {
                base: `${API_BASE_DOCTOR}/configurations`,
            }
        },
        zip:{
            endpoint: {
                base: `${API_BASE_DOCTOR}/zip`,
            }
        },
        invoices: {
            endpoint: {
                base: `${API_BASE_DOCTOR}/invoices`,
            }
        },
        calendars: {
            endpoint: {
                base: `${API_BASE_DOCTOR}/calendars`,
            }
        }
    },

    /**
     * 管理者向け設定
     */
    admin: {
        common: {
            endpoint: {
                timezone: `${API_BASE_ADMIN}/api/timezone`,
            },
        },
        medical_courses: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/medical_courses`,
            }
        },
        user_categories: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/user_categories`,
                add: `${API_BASE_ADMIN}/api/user_categories/add`,
            }
        },
        doctors: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/doctors`,
                all:`${API_BASE_ADMIN}/api/doctors/all`,
            }
        },
        doctor_menus: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/doctor_menus`,
            }
        },
        doctor_schedules: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/doctor_schedules`,
            }
        },
        users: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/users`,
                timezone: `${API_BASE_ADMIN}/api/timezone`,
                user_categories: `${API_BASE_ADMIN}/api/user_categories`,
            }
        },
        companies: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/companies`,
            }
        },
        organizations: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/organizations`,
            }
        },
        groups: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/groups`,
            }
        },
        user_management_tags: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/user_management_tags`,
            }
        },
        doctor_management_tags: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/doctor_management_tags`,
            }
        },
        group_management_tags: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/group_management_tags`,
            }
        },
        consultations: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/consultations`,
                attachedImages: `${API_BASE_ADMIN}/api/consultation/attached_images`,
                images: `${API_BASE_ADMIN}/api/consultation/images`,
            }
        },
        consultation_message_images: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/consultation_message_images`,
            },
        },
        consultation_feedback: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/consultation_feedback`,
            },
        },
        medical_records: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/medical_records`,
            },
        },
        doctor_memo: {
            endpoint: {
                base: `${API_BASE_ADMIN}/doctor_memo`,
            },
        },
        configurations: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/configurations`,
                all: `${API_BASE_ADMIN}/api/configurations/all`,
            }
        },
        cms_previews: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/cms_previews`,
            }
        },
        password: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/password`,
            }
        },
        zip:{
            endpoint: {
                base: `${API_BASE_ADMIN}/api/zip`,
            }
        },
        plans: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/plans`,
            }
        },
        payment_methods: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/payment_methods`,
                all: `${API_BASE_ADMIN}/api/payment_methods/all`,
            }
        },
        invoices: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/invoices`,
            }
        },
        interview_trans_profiles: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/interview_trans_profiles`,
            }
        },
        coupons: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/coupons`,
            }
        },
        coupon_codes: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/coupon_codes`,
            }
        },
        user_coupons: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/user_coupons`,
            }
        },
        profile: {
            endpoint: {
                timezone: `${API_BASE_ADMIN}/api/timezone`,
            }
        },
        interview_common_questions: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/interview_common_questions`,
            },
        },
        interview_questions: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/interview_questions`,
            },
        },
        interview_matching_questions: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/interview_matching_questions`,
            },
        },
        interview_trans_questions: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/interview_trans_questions`,
            },
        },
        subscriptions: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/subscriptions`,
            },
        },
        subscription_reviews: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/subscription_reviews`,
            },
        },
        audits: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/audits`,
            },
        },
        health_survey_templates: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/health_survey_templates`,
            }
        },
        health_survey_group_details: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/health_survey_group_details`,
            }
        },
        health_survey_questions: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/health_survey_questions`,
            },
        },
        health_surveys: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/health_surveys`,
            }
        },
        health_survey_reports: {
            endpoint: {
                base: `${API_BASE_ADMIN}/api/health_survey_reports`,
            }
        },
    },
};
